import React, { useState } from "react";
import { useNavigate } from "react-router-dom";



import ChooseAccount from "./steps/ChooseAccount";
import SignupLayout from "../../components/signupLayout/SignupLayout";
import CustomerReview from "./customer/CustomerReview";
import CustomerPreferences from "./customer/CustomerPreferences";
import CustomerPersonal from "./customer/CustomerPersonal";
import AdminReview from "./agent/AdminReview";
import AdminVerification from "./agent/AdminVerification";
import AdminAgency from "./agent/AdminAgency";
import AdminPersonal from "./agent/AdminPersonal";
import axios from "axios";
import { BASE_URL } from "../../config/config";
import { message } from "antd";

const SignUp = () => {
  const navigate = useNavigate();

  const [role, setRole] = useState(null);
  const [step, setStep] = useState(0);
  const [isLoading,setIsLoading] = useState(false)

  const [formData, setFormData] = useState({
    // Common
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    password: "",
    confirm_password: "",
    wallet_address : "",

    // Customer
    propertyType: "",
    bedrooms: "",
    budget: "",
    moveInTimeline: "",
    preferredLocations: "",
    amenities: [],

    designation: "",
    agencyName: "",
    licenseNumber: "",
    experience: "",
    specialization: "",
    professionalBio: "",
    verificationDocument: null,
  });

  
  const updateFormData = (data) => {
    setFormData((prev) => ({
      ...prev,
      ...data,
    }));
  };



  const handleRoleSelect = (selectedRole) => {
    setRole(selectedRole);
    setStep(1);
  };

  const handleNext = () => {
    setStep((prev) => prev + 1);
  };

  const handleBack = () => {
    if(step === 1){
        setRole(null)
    }else{
        setStep((prev) => Math.max(prev - 1, 0));
    }
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  const handleCreateAccount = async () => {
    setIsLoading(true)
    try {
      const payload = {
      ...formData
      };
      let response;
      if(role === "customer"){
        response = await axios.post(`${BASE_URL}/investor/register`,payload);
      }else{
        response = await axios.post(`${BASE_URL}/owner/register`,payload)
      }
      console.log(response,"Response")
      console.log("Signup payload:", payload);
      if(response?.data){
        navigate("/otp",
          {state: {
              email: formData?.email || "",
              role:role,
              from :"accountCreation"
            }})
      }
    } catch (error) {
      console.log("Signup failed:", error);
      message.error("Something Went Wrong. Please try Again")
    }finally{
      setIsLoading(false)
    }
  };


    return (
      <ChooseAccount
        onSelectRole={handleRoleSelect}
        onBack={handleBackToLogin}
      />
    );



  // if (role === "customer") {
  //   return (
  //     <SignupLayout
  //       role={role}
  //       step={step}
  //       totalSteps={3}
  //       onBack={handleBack}
  //       onLogin={() => navigate("/login")}
  //     >
  //       {step === 1 && (
  //         <CustomerPersonal
  //           data={formData}
  //           updateData={updateFormData}
  //           onNext={handleNext}
  //           onBack={handleBack}
  //         />
  //       )}

  //       {step === 2 && (
  //         <CustomerPreferences
  //           data={formData}
  //           updateData={updateFormData}
  //           onNext={handleNext}
  //           onBack={handleBack}
  //         />
  //       )}

  //       {step === 3 && (
  //         <CustomerReview
  //           data={formData}
  //           onBack={handleBack}
  //           onSubmit={handleCreateAccount}
  //           isLoading = {isLoading}
  //         />
  //       )}
  //     </SignupLayout>
  //   );
  // }


  // /* =====================================================
  //    ADMIN STEPS
  // ====================================================== */

  // return (
  //   <SignupLayout
  //     role={role}
  //     step={step}
  //     totalSteps={4}
  //     onBack={handleBack}
  //     onLogin={() => navigate("/login")}
  //   >
  //     {step === 1 && (
  //       <AdminPersonal
  //         data={formData}
  //         updateData={updateFormData}
  //         onNext={handleNext}
  //         onBack={handleBack}
  //       />
  //     )}
      
  //     {step === 2 && (
  //       <AdminVerification
  //         data={formData}
  //         updateData={updateFormData}
  //         onNext={handleNext}
  //         onBack={handleBack}
  //       />
  //     )}
  //     {step === 3 && (
  //       <AdminAgency
  //         data={formData}
  //         updateData={updateFormData}
  //         onNext={handleNext}
  //         onBack={handleBack}
  //       />
  //     )}

      

  //     {step === 4 && (
  //       <AdminReview
  //         data={formData}
  //         onBack={handleBack}
  //         onSubmit={handleCreateAccount}
  //       />
  //     )}
  //   </SignupLayout>
  // );
};

export default SignUp;